import { createAction, props } from '@ngrx/store';
import { Update } from '@ngrx/entity';

import {Citizens, CitizensInput} from './citizens.model';

export const loadCitizenss = createAction(
  '[Citizens/API] Load Citizenss',
  props<{ citizenss: Citizens[] }>()
);

export const addCitizens = createAction(
  '[Citizens/API] Add Citizens',
  props<{ citizens: Citizens }>()
);

export const upsertCitizens = createAction(
  '[Citizens/API] Upsert Citizens',
  props<{ citizens: Citizens }>()
);

export const addCitizenss = createAction(
  '[Citizens/API] Add Citizenss',
  props<{ citizenss: Citizens[] }>()
);

export const upsertCitizenss = createAction(
  '[Citizens/API] Upsert Citizenss',
  props<{ citizenss: Citizens[] }>()
);

export const updateCitizens = createAction(
  '[Citizens/API] Update Citizens',
  props<{ citizens: Update<Citizens> }>()
);

export const updateCitizenss = createAction(
  '[Citizens/API] Update Citizenss',
  props<{ citizenss: Update<Citizens>[] }>()
);

export const deleteCitizens = createAction(
  '[Citizens/API] Delete Citizens',
  props<{ id: string }>()
);

export const deleteCitizenss = createAction(
  '[Citizens/API] Delete Citizenss',
  props<{ ids: string[] }>()
);

export const clearCitizenss = createAction(
  '[Citizens/API] Clear Citizenss'
);


export const createCitizenMutation = createAction(
  '[Citizens/API] Create Citizens Mutation',
  props<{ input: CitizensInput }>()
)
